export const DIAGNOSIS_MODALS_NAMES = {
  imeiModal: 'imeiModal',
  imeiUnavailableModal: 'imeiUnavailableModal',
  insurerPortalModal: 'insurerPortalModal',
  invoiceRequestModal: 'invoiceRequestModal',
  invoiceRequestModalCanceled: 'invoiceRequestModalCanceled',
  invoiceRequestPendingModal: 'invoiceRequestPendingModal',
  preShippingInvoiceRequestModal: 'preShippingInvoiceRequestModal',
}
